import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
}

const styles = (width: number | undefined, height: number | undefined): IStyles => ({
  wrapper: {
    position: 'absolute',
    zIndex: 10,
    top: '0px',
    right: '0px',
    width: width ? width : '55px',
    height: height ? height : '55px',
  },
});

export default styles;
